export class SelectionPermissions {
    // MAKE ALL FALSE ONCE TESTING IS DONE
    HasDelete = false; // Permit[614]
    HasUnlock = false; // Permisos[314]
    HasAlarma = false; // Permisos[309]
    HasAviso = false; // Permisos[309]
    HasConsentimento = false; // Permisos[308]
    HasExcel = false; // Permiso[205]
    HasWord = false; // Permiso[206]
    HasDiagnosis = false; // Permisos[505]
    HasPsychosocialRisks = false; // Permisos[516]
    HasCompanyMark = false; // Permisos[306]
    HasMutualityMark = false; // Permisos[306]
    HasExternalMark = false; // Permisos[223]
    HasDiagnosisMark = false; // Permisos[306]
    HasZoneMark = false; // Permisos[306]
    HasAbsenteismMark = false; // Permisos[305]
    HasChronicalMark = false; // Permisos[505]
    HasPregnedMark = false; // Permisos[505]
    HasDischargeDateBeforeTaskMark = false; // Permisos[211]
    HasSurgeryMark = false; // Permisos[505]
    HasWithoutEstimatedMark = false; // Permisos[211]
    HasWithoutManagingMark = false; // Permisos[211]
    HasLeavesWithoutTasksMark = false; // Permisos[211]
    HasWithoutVisitsMark = false; // Permisos[211]
    HasUrgentPositionMark = false; // Permisos[306]
    HasPES = false; // Permisos[409]
    HasMarcaView = false; // Permisos[212]
    HasMarcaExternalView = false; // Permisos[223]
    HasEmbarazada = false; // Permisos[515]
    HasAbsentista = false; // Permisos[305]
    HasFechaRevision = false; // Permisos[511]
    HasUsuario = false; // Permisos[510]
    HasFacturacion = false; //Permisos[502]
    HasGrabacion = false; // Permisos[519]
    HasDocumento = false; // Permisos[520]
    HasImporteMedico = false; // Permisos[514] && [510]
    HasTexto = false; // Permisos[501]
    HasRespSol = false; // Permisos[619]
    HasPermisos505 = false; // Permisos[505]
    HasPermisos510 = false; // Permisos[510]
    HasPermisos511 = false; // Permisos[511]
    HasPermisos208 = false; // Permisos[208]
    HasPermisos222 = false; // Permisos[222]
    HasTereaSelectionComentario = false; // Permisos[517],Permisos[518]
    HasTereaEnvio = false; // Permisos[510]
    HasTereaRealizada = false; // Permisos[510]
    HasTereaFReclamacion = false; // Permisos[215]
    HasTereaReclTelefonica = false; // Permisos[215]
    HasTereaReclUSuario = false; // Permisos[215]
    HasTereaReclObs = false; // Permisos[215]
    HasPermisos405 = false; // Permisos[505]
}
